import { styles } from './template.scss';

export const templateNetworkV2App = document.createElement('template');

templateNetworkV2App.innerHTML = `
  <style>${styles}</style>

  <div class="wrapper" />
`;
